module.exports = __webpack_public_path__ + "img/P5.9bbf61b2.png";